import { Injectable, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { BaseService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-service.component";
import { Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { Observable, of } from "rxjs";
import { map, mergeMap, take, takeUntil } from "rxjs/operators";
import { CustomerFormComponent } from "src/app/frontoffice/parties/customer/customer-form.component";
import { DeliveryCustomerPrintTime, SaleMethodNature } from "src/app/frontoffice/sales/model/sale-method-branch.model";
import { NumberType } from "../../../../../../../projects/sepidz-web-framework/src/lib/models/enums";
import { CustomerDetailInfoViewModel } from "../../../../parties/model/customer.model";
import { DiscountTypeEnum, Invoice, InvoiceCommand, InvoiceStatus } from "../../../model/invoice.model";
import { OrderActionEnum } from "../../../model/orderactioncontrol.model";
import { PaymentMethodEnum } from "../../../model/paymentmethod.enum";
import { OrderService } from "../../../order.service";
import { InvoiceActionService } from "../../../providers/invoiceaction.service";
import { CustomerPrintTemplateFormComponent } from "../customer-print-template-form/customer-print-template-form/customer-print-template-form.component";
import { PaymentComponent } from "../payment/payment.component";
import { PreparationDeliveryTimeFormComponent } from "../preparation-delivery-time-form/preparation-delivery-time-form.component";

@Injectable({
  providedIn: "root",
})
export class TotalPriceService extends BaseService implements OnInit, OnDestroy {
  readOnlyRent: boolean;
  invoice: Invoice;
  _rotate: boolean;
  isPercent: boolean;
  isShowAdvanse: boolean = true;
  currentRow: any;
  _invoiceStatus: typeof InvoiceStatus = InvoiceStatus;
  orderActionEnum: typeof OrderActionEnum = OrderActionEnum;
  hasDefultPayment: boolean;
  isPosPayment: boolean;
  isTabletPosPayment: boolean;
  showPrintButton: boolean;
  showChangeClearing: boolean;
  public isStartAction: number = 0;
  invoiceCommand: typeof InvoiceCommand = InvoiceCommand;
  showMorePrint: boolean = false;
  printTamplateList: Lookup[] = [];
  PrintTemplatesClear: Lookup[] = [];
  printTitle: string;
  showDiscount: boolean = false;
  HasHappyHour: boolean = false;
  saleMethodNatureCode: number;
  changeByUser: boolean = false;
  oldDiscountPercent: number;
  discountTypeEnum: typeof DiscountTypeEnum = DiscountTypeEnum;
  changeDiscountType: boolean = false;
  clearDiscountFlag: boolean = false;
  hasTemporary: boolean;

  constructor(public order: OrderService, public invoiceAction: InvoiceActionService, public common: CommonService) {
    super();
    this.fillData(this.order.invoice?.Id ? false : true);
    this.hasPermissionDiscount();
    this.HasTemporaryRegistration();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["currentSaleMethodBranch"].currentValue && this.order.saleMethodBranch) {
      this.showPrintButton = this.order.saleMethodBranch.DeliveryCustomerPrintTimeCode === DeliveryCustomerPrintTime.PreparationPrint;
    }
  }
  hasPermissionDiscount() {
    if (this.order.HasAccess("GiveDiscount")) {
      this.showDiscount = true;
    }
  }
  ngOnDestroy() {}
  ngOnInit() {}
  fillData(applyDiscount: boolean = false) {
    if (!this.order.HasAccess("EditShippingCost")) {
      this.readOnlyRent = true;
    }
    this.readOnlyRent = false;
    this.hasDefultPayment = this.order.saleMethodBranch?.PaymentMethods?.some((s) => s.IsDefault);
    const DefultPaymentId = this.order.saleMethodBranch?.PaymentMethods?.find((s) => s.IsDefault)?.PaymentMethodId;
    if (DefultPaymentId) {
      const findItem = this.order.paymentMethodTypeLookup.find((f) => f.Id === DefultPaymentId).PaymentMethodCode;
      if (findItem && findItem === PaymentMethodEnum.Pos) this.isPosPayment = findItem === PaymentMethodEnum.Pos;
      if (findItem && findItem === PaymentMethodEnum.TabletPos) this.isTabletPosPayment = findItem === PaymentMethodEnum.TabletPos;
    }
    //this.isDebit = (this.order.invoice.Debit > 0 || (this.order?.invoice?.Customer?.HasCredit) || this.order?.invoice?.Customer?.AutomaticDebtor) ? true : false;
    this.order.setValue("Discount", this.order.invoice.Discount);
    if (this.order?.invoice?.Customer?.HasCredit) {
      this.order.invoice.isDebit = true;
      if (this.order.invoice.Debit > 0) this.order.invoice.isDebit = true;
      if (this.order.invoice.Credit > 0) this.order.invoice.isDebit = false;
      this.order.setValue("Debit", this.order.invoice.isDebit ? this.order.invoice.Debit : this.order.invoice.Credit);
    }
    this.order.happyHourDiscountValidation();
    this.applyDiscount(this.order.invoice.Discount?.toString() ?? "", null, false, this.order.itemChanged);
    this.order.detectChanges();
  }
  //DiscountFocus
  onDiscountfocus() {
    if (this.order.formGroup.controls["Discount"].value === "0" || this.order.formGroup.controls["Discount"].value === 0) {
      this.order.setValue("Discount", "");
    }
  }
  //اعمال هزینه بسته بندی
  applyPackingPrice(value: string) {
    if (this.order.formGroup.controls["PackingPrice"].value) this.order.invoice.isPackingDisable = true;
    this.order.invoiceChanged = true;
    this.order.itemChanged = true;
    this.order.calculate();
    this.order.detectChanges();
  }
  //Clear PackingPrice
  clearPackingPrice() {
    this.order.invoice.PackingPrice = 0;
    this.order.setValue("PackingPrice", 0);

    this.order.invoice.isPackingDisable = true;
    this.order.invoiceChanged = true;
    this.order.itemChanged = true;
    this.order.calculate();
    this.order.detectChanges();
  }
  //تغییر کاربر روی تخٝیٝ
  inputChange() {
    this.order.invoice.DiscountType = DiscountTypeEnum.User;
    this.order.validHappyHour = false;
  }
  //اعمال تخفیف
  applyDiscount(value: string, isPercent: boolean, changed: boolean = false, itemChanged: boolean = true) {
    this.order.invoiceChanged = true;
    this.order.itemChanged = itemChanged;
    if (isPercent != null) {
      this.order.invoice.changeDiscountType = true;
      this.order.invoice.IsDiscountPercent = isPercent;
      this.order.invoice.Discount = 0;
      this.order.invoice.DiscountType = DiscountTypeEnum.None;
      this.order.validHappyHour = false;
      this.order.invoice.TotalDiscount = 0;
      this.order.invoice.DiscountPrice = 0;
      this.order.setValue("Discount", null);
      this.order.calculate();
      this.order.detectChanges();
      return;
    }
    let discountValue = Number(this.order.formGroup.controls["Discount"].value);
    if (this.order.invoice.IsDiscountPercent) {
      this.order.invoice.Discount = discountValue;
      if (Number(value) > 100) {
        value = "100";
        this.order.invoice.Discount = Number(value);
      }
    } else {
      this.order.invoice.Discount = discountValue;
      if (this.order.invoice.PayableTotalLessDiscount < discountValue && discountValue > 0 && this.order.invoice.Items.length > 0) {
        this.order.sts.showToast(
          "danger",
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.PossibleEnterDiscount"),
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Attention")
        );
      }
    }
    this.order.formGroup.controls["Discount"].setValue(this.order.invoice.Discount);
    this.order.invoiceChanged = true;
    if (this.order.invoice.DiscountType === DiscountTypeEnum.User) {
      if (this.order.invoice.IsDiscountPercent) {
        if (this.order.currentUser.PercentDiscount)
          if (Number(value) > this.order.currentUser.PercentDiscount) this.order.invoice.Discount = this.order.currentUser.PercentDiscount;
      } else {
        if (this.order.currentUser.RialDiscount)
          if (Number(value) > this.order.currentUser.RialDiscount) this.order.invoice.Discount = this.order.currentUser.RialDiscount;
      }
    }
    this.order.calculate();
  }

  //Clear Discount
  clearDiscount() {
    this.oldDiscountPercent = this.order.invoice.Discount;
    this.clearDiscountFlag = true;
    this.order.shouldCalculateFreeShippingCost = false;
    this.order.invoiceChanged = true;
    this.order.itemChanged = true;
    this.order.detectChanges();
    this.HasHappyHour = false;
    this.order.invoice.DiscountType = DiscountTypeEnum.User;
    this.order.calculate(null, true);
  }
  //اعمال کرایه
  applyShippingCost(value: number) {
    //else {
    if (!value) return;
    this.order.invoice.ShippingCost = Number(value);
    //}
    if (!value) return;
    this.order.invoiceChanged = true;
    this.order.itemChanged = true;
    this.order.calculate();
  }

  //حذٝ کرایه
  clearShippingCost() {
    this.order.invoice.ShippingCost = null;
    this.order.formGroup.controls["ShippingCost"].setValue(0);
    this.order.invoiceChanged = true;
    this.order.itemChanged = true;
    this.order.calculate();
  }

  //اعمال بدهکاری
  applyDebit(value: string, isDebit: boolean) {
    if (isDebit != null) {
      this.order.invoice.isDebit = isDebit;
    }
    if (this.order.invoice.isDebit) {
      if (this.order.formGroup.controls["Debit"].value != this.order.invoice.Debit && this.order.invoice.Debit > 0)
        this.order.invoice.isDebitDisable = true;
      else {
        this.order.invoice.isDebitDisable = false;
      }
      this.order.invoice.Credit = 0;
      this.order.invoice.Debit = this.order.formGroup.controls["Debit"].value;
    } else {
      this.order.invoice.isDebitDisable = true;
      this.order.invoice.Debit = 0;
      this.order.invoice.Credit = this.order.formGroup.controls["Debit"].value;
    }
    if (this.order.invoice.Debit !== this.order.formGroup.controls["Debit"].value) {
      this.order.invoiceChanged = true;
    } else {
      this.order.invoiceChanged = true;
    }
    this.order.calculate();
  }

  clearAndPrintTabletPos() {
    this.invoiceAction.tabletPos.tabletPosPrint(this.order.invoice, this.accountService.authService.currentInformation().BrandName);
    this.clear(InvoiceCommand.Clear);
  }

  /// انتقال کل مبلغ فاکتور به بدهکاری زمانی که مشترک اتوماتیک بدهکار داشته باشد
  debitTransfer() {
    if (this.order.currentSaleMethodNature === this.order.SaleMethodNature.Delivery && this.order.invoice?.Customer?.HasCredit) {
      this.order.invoice.isDebitDisable = false;
      this.order.invoice.isDebit = true;
      this.order.invoice.Credit = 0;
      this.order.invoice.Debit = this.order.invoice.PayableTotal;
      this.order.formGroup.controls["Debit"].setValue(this.order.invoice.Debit);
      this.order.invoiceChanged = true;
      this.order.itemChanged = true;
      this.order.calculate();
    }
  }

  //مودال پرداخت
  openMixClearingDialog(isClearWithoutPrint?: Boolean) {
    this.invoiceAction.order = this.order;
    if (!this.invoiceAction.isValid(this.order.invoice)) return;
    if (!this.order.isLight && !this.order.stockDialogIsOpened) {
      const notStockList = this.invoiceAction.getNotStockList(this.order.invoice);
      if (notStockList.length) {
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.FollowingItemsUnavailable")}: <br/>
          ${notStockList.join(" <br/> ")}
          `,
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.NoStock"),
          DialogType.confirm,
          () => {
            this.order.stockDialogIsOpened = true;
            this.openMixClearingDialog(isClearWithoutPrint);
          },
          () => {
            this.order.stockDialogIsOpened = false;
          }
        );
        this.order.stockDialogIsOpened = true;
        return false;
      }
    }
    if (this.order.invoice.PayableTotal === 0 && this.order.invoice.TotalDiscount > 0) {
      this.invoiceAction.SaveInvoice(InvoiceCommand.Clear, this.order.invoice, null, this.order);
      this.invoiceAction.saveEnd.pipe(take(1)).subscribe((res) => {
        if (res) this.order.setActivePage();
      });
      return;
    }
    if (
      this.order.saleMethodBranch.PreprationTimeRequired &&
      !this.order.invoice.PreprationDeliveryTime &&
      this.order.invoice.PreparationPrintCount < 1 &&
      this.order.invoice.CustomerPrintCount < 1
    ) {
      this.dialogService
        .open(PreparationDeliveryTimeFormComponent, {
          label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.DeliveryTime"),
        })
        .pipe(take(1))
        .subscribe((preparationDeliveryTime) => {
          if (preparationDeliveryTime) {
            this.order.invoice.PreprationDeliveryTime = preparationDeliveryTime;
            this.dialogService
              .open(
                PaymentComponent,
                { order: this.order, isClearWithoutPrint: isClearWithoutPrint, invoiceAction: this.invoiceAction, group: null },
                { closeOnClickOutside: false }
              )
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((model) => {
                if (model) this.order.newInvoice();
              });
          } else {
            this.sts.showToast(
              "danger",
              this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Error"),
              `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.SelectDeliveryTime")}`
            );
          }
        });
    } else {
      this.dialogService
        .open(
          PaymentComponent,
          { order: this.order, isClearWithoutPrint: isClearWithoutPrint, invoiceAction: this.invoiceAction, group: null },
          { closeOnClickOutside: false }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {
          if (model) this.order.newInvoice();
        });
    }
  }
  // انتخاب نحوه باز کردن تسویه
  clear(Action?: InvoiceCommand) {
    this.fillData();
    this.showCustomerForm(Action)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.order.invoice?.ReceiptPayments?.forEach((x) => {
            x.PaymentMethodCode = this.order.paymentMethodTypeLookup?.find((f) => f.Id === x.PaymentMethodId)?.PaymentMethodCode;
          });

          if (
            (this.order.invoice.PayableTotal > 0 &&
              this.order.invoice?.OriginalValue?.StatusCode == InvoiceStatus.Cleared &&
              this.order.invoice?.OriginalValue?.PayableTotal > 0 &&
              this.order.invoice.PayableTotal === this.order.invoice?.OriginalValue?.PayableTotal &&
              this.order.invoice.Debit === this.order.invoice?.OriginalValue?.Debit) ||
            (this.hasDefultPayment &&
              (!this.order.invoice?.OriginalValue?.PayableTotal ||
                this.order.invoice?.PayableTotal >= this.order.invoice?.OriginalValue?.PayableTotal) &&
              this.order.invoice?.OriginalValue?.StatusCode !== InvoiceStatus.Cleared &&
              !this.order.invoice?.Customer?.HasCredit)
          )
            this.invoicesAction(
              Action
                ? Action
                : this.isPosPayment
                ? InvoiceCommand.PosPayment
                : this.isTabletPosPayment
                ? InvoiceCommand.PosPayment
                : InvoiceCommand.Clear
            );
          else this.openMixClearingDialog(Action === InvoiceCommand.ClearWithoutPrint);
        }
      });
  }

  delivered() {
    if (this.order.currentSaleMethodNature !== SaleMethodNature.Delivery) {
      this.invoicesAction(InvoiceCommand.Clear);
    } else this.invoicesAction(InvoiceCommand.PreparationPrint);
  }

  //-------------------------------------------------------------Begin HelpMethod
  public stateChange(): void {
    // this.openTotalPrice = !this.openTotalPrice;
    this.order.OrderSetting.IsShowTotalBox = !this.order.OrderSetting.IsShowTotalBox;
    this.common.updateSettings(this.order.OrderSetting);
    // this.onStateChange.emit();
  }
  public async invoicesAction(Action: InvoiceCommand) {
    if (this.order.invoice.Items?.length <= 0) {
      this.order.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.BasketIsEmpty"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Attention")
      );
      return;
    }
    this.invoiceAction.isStartAction++;
    this.showCustomerForm(Action)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          switch (Action) {
            case InvoiceCommand.Save:
              this.invoiceAction.SaveInvoice(this.invoiceCommand.Save, this.order.invoice, null, this.order);
              break;
            case InvoiceCommand.TemporaryRegister:
              this.invoiceAction.SaveInvoice(this.invoiceCommand.TemporaryRegister, this.order.invoice, null, this.order);
              break;
            case InvoiceCommand.PreparationPrint:
              this.invoiceAction.SaveInvoice(this.invoiceCommand.PreparationPrint, this.order.invoice, null, this.order);
              break;
            case InvoiceCommand.CustomerPrint:
              this.invoiceAction.SaveInvoice(this.invoiceCommand.CustomerPrint, this.order.invoice, null, this.order);
              break;
            case InvoiceCommand.CustomerTabletPrint:
              this.invoiceAction.SaveInvoice(this.invoiceCommand.CustomerTabletPrint, this.order.invoice, null, this.order);
              break;
            case InvoiceCommand.Print:
              this.invoiceAction.SaveInvoice(this.invoiceCommand.Print, this.order.invoice, null, this.order);
              break;
            case InvoiceCommand.Clear:
              this.invoiceAction.SaveInvoice(this.invoiceCommand.Clear, this.order.invoice, null, this.order);
              break;
            case InvoiceCommand.PosPayment:
              this.invoiceAction.SaveInvoice(this.invoiceCommand.PosPayment, this.order.invoice, null, this.order);
              break;
            case InvoiceCommand.ClearWithoutPrint:
              this.invoiceAction.SaveInvoice(this.invoiceCommand.ClearWithoutPrint, this.order.invoice, null, this.order);
              break;
            case InvoiceCommand.CustomerFinancialPrint:
              this.invoiceAction.SaveInvoice(this.invoiceCommand.CustomerFinancialPrint, this.order.invoice, null, this.order);
              break;
            case InvoiceCommand.CustomerA5Print:
              this.invoiceAction.SaveInvoice(this.invoiceCommand.CustomerA5Print, this.order.invoice, null, this.order);
              break;
            case InvoiceCommand.CustomerFinancialA5Print:
              this.invoiceAction.SaveInvoice(this.invoiceCommand.CustomerFinancialA5Print, this.order.invoice, null, this.order);
              break;
            default:
              return;
          }
        }
        this.invoiceAction.saveEnd.pipe(take(1)).subscribe((res) => {
          if (res === true) this.order.newInvoice();
          else {
            const DefultPaymentId = this.order.saleMethodBranch?.PaymentMethods?.find((s) => s.IsDefault)?.PaymentMethodId;
            if (DefultPaymentId && res) {
              const findItem = this.order.paymentMethodTypeLookup.find((f) => f.Id === DefultPaymentId).PaymentMethodCode;
              let isPosPayment: boolean, isTabletPosPayment: boolean;
              if (findItem && findItem === PaymentMethodEnum.Pos) isPosPayment = findItem === PaymentMethodEnum.Pos;
              if (findItem && findItem === PaymentMethodEnum.TabletPos) isTabletPosPayment = findItem === PaymentMethodEnum.TabletPos;
              if (isPosPayment || isTabletPosPayment) {
                this.httpCommonService
                  .getItem("Invoice/GetInvoiceById", res.Id)
                  .pipe(take(1))
                  .subscribe((invoice: Invoice) => {
                    this.invoiceAction.SaveInvoice(InvoiceCommand.Clear, invoice, null, this.order);
                    this.invoiceAction.saveEnd.pipe(take(1)).subscribe((res: boolean | Invoice) => {
                      if (res === true) {
                        this.invoiceAction.isStartAction = 0;
                        this.order.newInvoice();
                      }
                    });
                  });
              }
            }
          }
        });
        this.invoiceAction.ActionFinish.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
          this.invoiceAction.isStartAction = 0;
          this.order.detectChanges();
        });
      });
  }
  // This function runs when subscribe() is called
  getValueFromObservable(): Observable<any> {
    return;
  }

  /* نمایش فرم ایجاد مشتری در صورت داشتن کد باشگاه */
  showCustomerForm(Action?: InvoiceCommand): Observable<boolean> {
    let MobileLookupId: number = this.order.PhoneTypeLookup.find((f) => f.Code === NumberType.Mobile).Id;
    const saleMethodBranch = this.order.saleMethodBranch;
    if (
      saleMethodBranch.HasNecessaryMobile &&
      (this.order.invoice.Customer.Number === 0 || !this.order.invoice?.Customer?.Numbers?.some((s) => s.NumberTypeId === MobileLookupId))
    ) {
      if (
        this.order.SaleMethodNature.Restaurant === this.order.currentSaleMethodNature &&
        Action !== InvoiceCommand.Clear &&
        Action !== InvoiceCommand.ClearWithoutPrint &&
        (this.order.invoice.StatusCode === InvoiceStatus.Ordering ||
          this.order.invoice.StatusCode === InvoiceStatus.New ||
          this.order.invoice.StatusCode === InvoiceStatus.Pending)
      ) {
        return Observable.of(true);
      }

      if (!this.order.customerFormIsShowBefore) {
        this.order.customerFormIsShowBefore = true;
        return this.dialogService
          .open(
            CustomerFormComponent,
            {
              label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.SubscriberWithoutNewSubscription"),
              hasClubCustomer: true,
              nameIsNotNecessary: !saleMethodBranch.HasNecessaryName,
              apiName: "Customer",
              LastName: this.order.invoice.Customer.LastName,
              currentrow: this.order.invoice.Customer.Number === 0 ? null : this.order.invoice?.Customer,
            },
            { autoFocus: true, closeOnClickOutside: false, closeOnEscape: false }
          )
          .pipe(
            take(1),
            mergeMap((ele) => {
              if (ele) {
                return this.httpCommonService.getItem("Customer/GetCustomerDetails", ele.Id).pipe(
                  take(1),
                  map((data: CustomerDetailInfoViewModel) => {
                    if (data?.Numbers.some((s) => s.NumberTypeId === MobileLookupId)) {
                      this.order.invoice.Customer = ele;
                      this.order.invoice.CustomerId = ele.Id;
                      this.order.invoice.Customer.Number = ele.Number;
                      this.order.invoice.CustomerDisplayName = data.DisplayName;
                      this.order.invoice.PhoneNumber = ele.PhoneNumber;
                      this.order.invoice.PhoneId = data?.Numbers?.find((f) => f.IsDefault)?.Id;
                      this.order.invoice.CustomerAddres = ele.Address;
                      this.order.invoice.AddressId = data.Addresses?.find((f) => f.IsDefault)?.Id;
                      this.order.detectChanges();
                      this.invoiceAction.isStartAction = 0;
                      return true;
                    } else {
                      this.invoiceAction.isStartAction = 0;
                      this.order.detectChanges();
                      return false;
                    }
                  })
                );
              } else {
                this.invoiceAction.isStartAction = 0;
                this.order.detectChanges();
                return of(true);
              }
            })
          );
      } else return of(true);
    } else {
      return of(true);
    }
  }

  changePrintTemplate(invoice?: Invoice) {
    if (invoice) {
      this.httpCommonService
        .getItem("Invoice/GetInvoiceById", invoice.Id)
        .pipe(take(1))
        .subscribe((invoice: Invoice) => {
          this.order.invoice = invoice;
        });
    }
    this.dialogService
      .open(CustomerPrintTemplateFormComponent, {
        order: this.order,
        areaName: "RestaurantSale",
        invoiceAction: this.invoiceAction,
        label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.CustomerPrintTemplate"),
      })
      .pipe(take(1))
      .subscribe((model) => {
        if (model) {
          this.order.invoice.OtherPrintTemplateId = model;
          if (invoice) {
            invoice.OtherPrintTemplateId = model;
            this.invoiceAction.SaveInvoice(invoice.CommandCode, invoice, true, this.order);
          } else {
            if (this.order.SaleMethodNature.Delivery === this.order.currentSaleMethodNature)
              this.invoiceAction.SaveInvoice(InvoiceCommand.PreparationPrint, this.order.invoice, null, this.order);
            else if (this.order.SaleMethodNature.FastFood === this.order.currentSaleMethodNature) this.clear();
            else if (this.order.SaleMethodNature.Restaurant === this.order.currentSaleMethodNature)
              this.invoiceAction.SaveInvoice(InvoiceCommand.CustomerPrint, this.order.invoice, null, this.order);
          }
        }
      }),
      500;
    this.order.detectChanges();
  }

  setDeliveryTime() {
    this.dialogService
      .open(PreparationDeliveryTimeFormComponent, { label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.DeliveryTime") })
      .pipe(take(1))
      .subscribe((preparationDeliveryTime) => {
        if (preparationDeliveryTime) {
          this.order.invoice.PreprationDeliveryTime = preparationDeliveryTime;
        }
      }),
      500;
  }
  HasTemporaryRegistration() {
    if (this.order.HasAccess("TemporaryRegistration")) this.hasTemporary = true;
  }
}
